import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";

import "./Offer.css";
import Header from "../Shared/Header/Header";
import SubHeader from '../Shared/SubHeader/SubHeader';
import Footer from "../Shared/Footer/Footer";

import adhd from "../../images/specialities/adhd.png";
import autism from "../../images/specialities/autism.png";
import consultations from "../../images/specialities/depression.png";
import personality from "../../images/specialities/personality.png";
import anxiety from "../../images/specialities/ptsd.png";

const Offer = () => {

  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);

  return (
    <>
      <Header />
      <SubHeader title="Oferta" subtitle="Kompleksowa opieka nad Twoim zdrowiem psychicznym." />
      
      <div className="offers" style={{marginTop:'2rem'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mt-3">
              <div className="member d-flex flex-column align-items-start h-100">
              <div>
                <div className="offer-img offer-item text-center">
                  <img src={adhd} className="img-fluid" alt="" />
                </div>
                <div className="member-info">
                  <h4 style={{marginBottom:"2rem", textAlign:"center"}}>
                    DIAGNOZA ADHD U DOROSŁYCH
                  </h4>
                  <p>
                    <p>
                      W dorosłości ADHD często objawia się jako chroniczne rozkojarzenie, trudności z organizacją 
                      czasu, impulsywność, poczucie przeciążenia i niska tolerancja na frustrację. 
                      Osoby z niezdiagnozowanym ADHD mogą latami zmagać się z nieefektywnością zawodową,
                       napięciami w relacjach i niskim poczuciem własnej wartości.
                    </p>

                    <p>
                      W Synavie diagnoza ADHD przebiega całkowicie online i obejmuje:
                    </p>
                    <ul>
                      <li>wywiad kliniczny z psychologiem (ok. 120 min)</li>
                      <li>ustrukturyzowany wywiad diagnostyczny DIVA-5.0</li> 
                      <li>analizę historii rozwoju objawów od dzieciństwa po dorosłość</li>
                      <li>opracowanie opinii diagnostycznej z wnioskami i rekomendacjami.</li>
                    </ul>

                    <p>
                      <strong>Czas trwania:</strong> do 2 godzin<br />
                      <strong>Czas oczekiwania na wynik:</strong> 48 godzin roboczych<br />
                      <strong>Cena:</strong> 500 zł
                    </p>
                  </p>
                  <div className="text-end" style={{marginTop:'2rem'}}>
                    <Link to={`/umow-wizyte`} className="more-btn">
                      <BsFillArrowRightCircleFill /> Umów się na wizytę
                      <i className="bx bx-chevron-right"></i>
                    </Link>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-6 mt-3" id="autyzm">
              <div className="member d-flex flex-column align-items-start h-100">
              <div>
                <div className="offer-img offer-item text-center">
                  <img src={autism} className="img-fluid" alt="" />
                </div>
                <div className="member-info">
                  <h4 style={{marginBottom:"2rem", textAlign:"center"}}>
                    DIAGNOZA SPEKTRUM AUTYZMU (ASD)
                  </h4>
                  <p>
                    <p>
                      Zaburzenia ze spektrum autyzmu u dorosłych często pozostają nierozpoznane – osoby te 
                      mogą mieć trudności w rozumieniu społecznych norm, odczuwać nadwrażliwość sensoryczną, 
                      preferować rutynę i wykazywać nietypowe sposoby komunikacji.
                    </p>

                    <p>
                      Nasza diagnoza ASD obejmuje:
                    </p>
                    <ul>
                      <li>pogłębiony wywiad rozwojowy (ok. 90 min),</li>
                      <li>testy przesiewowe (np. AQ, RAADS-R),</li>
                      <li>ocenę funkcjonowania społecznego i poznawczego,</li>
                      <li>analizę różnic w prezentacji objawów u kobiet i osób maskujących,</li>
                      <li>konsultację końcową i pełną opinię psychologiczną.</li>
                    </ul>

                    <p>
                      <strong>Czas trwania:</strong> ok. 4–5 godzin (rozłożonych na 2–3 sesje)<br />
                      <strong>Czas oczekiwania na wynik:</strong> do 3 dni roboczych<br />
                      <strong>Cena:</strong> 800 zł
                    </p>
                  </p>
                  <div className="text-end" style={{marginTop:'2rem'}}>
                    <Link to={`/umow-wizyte`} className="more-btn">
                      <BsFillArrowRightCircleFill /> Umów się na wizytę
                      <i className="bx bx-chevron-right"></i>
                    </Link>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 mt-3">
              <div className="member d-flex flex-column align-items-start h-100">
              <div>
                <div className="offer-img offer-item text-center">
                  <img src={personality} className="img-fluid" alt="" />
                </div>
                <div className="member-info">
                  <h4 style={{marginBottom:"2rem", textAlign:"center"}}>
                    DIAGNOZA ZABURZEŃ OSOBOWOŚCI
                  </h4>
                  <p>
                    <p>
                      Zaburzenia osobowości wpływają na sposób, w jaki interpretujemy siebie i innych, 
                      reagujemy emocjonalnie, tworzymy relacje i kontrolujemy impulsy.
                    </p>
                    <p>
                      W Synavie oferujemy diagnozę osobowości opartą na:
                    </p>
                    <ul>
                      <li>rozmowie klinicznej</li>
                      <li>standaryzowanym teście MMPI-2-RF lub SCID-5-PD</li>
                      <li>analizie stylu funkcjonowania i mechanizmów obronnych</li>
                      <li>opracowaniu opinii psychologicznej przydatnej także w kontekście terapii.</li>
                    </ul>

                    <p>
                      <strong>Czas trwania:</strong> 2–3 godziny (część zdalna i część testowa)<br />
                      <strong>Czas oczekiwania na wynik:</strong> do 72 godzin<br />
                      <strong>Cena:</strong> 600 zł
                    </p>
                  </p>
                  <div className="text-end" style={{marginTop:'2rem'}}>
                    <Link to={`/umow-wizyte`} className="more-btn">
                      <BsFillArrowRightCircleFill /> Umów się na wizytę
                      <i className="bx bx-chevron-right"></i>
                    </Link>
                  </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mt-3">
              <div className="member d-flex flex-column align-items-start h-100">
              <div>
                <div className="offer-img offer-item text-center">
                  <img src={anxiety} className="img-fluid" alt="" />
                </div>
                <div className="member-info">
                  <h4 style={{marginBottom:"2rem", textAlign:"center"}}>
                    DIAGNOZA ZABURZEŃ LĘKOWYCH
                  </h4>
                  <p>
                    <p>
                      Zaburzenia lękowe mogą przyjmować wiele form: lęk uogólniony (ciągłe 
                      zamartwianie się), fobie społeczne, napady paniki, natręctwa. Objawy 
                      mogą prowadzić do wycofania się z życia społecznego i zawodowego.
                    </p>
                    <p>
                      Nasza usługa to szybka ścieżka diagnostyczna:
                    </p>
                    <ul>
                      <li>1-godzinna konsultacja z psychologiem</li>
                      <li>ocena przy pomocy skal (np. GAD-7, BAI)</li>
                      <li>klasyfikacja wg ICD-11</li>
                      <li>rekomendacje co do dalszego leczenia lub terapii.</li>
                    </ul>

                    <p>
                      <strong>Czas trwania:</strong> ok. 1 godzina<br />
                      <strong>Czas oczekiwania na wynik:</strong> do 24 godzin<br />
                      <strong>Cena:</strong> 300 zł
                    </p>
                  </p>
                  <div className="text-end" style={{marginTop:'2rem'}}>
                    <Link to={`/umow-wizyte`} className="more-btn">
                      <BsFillArrowRightCircleFill /> Umów się na wizytę
                      <i className="bx bx-chevron-right"></i>
                    </Link>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 mt-3">
              <div className="member d-flex flex-column align-items-start h-100">
              <div>
                <div className="offer-img offer-item text-center">
                  <img src={consultations} className="img-fluid" alt="" />
                </div>
                <div className="member-info">
                  <h4 style={{marginBottom:"2rem", textAlign:"center"}}>
                    KONSULTACJE PSYCHOLOGICZNE
                  </h4>
                  <p>
                    <p>
                      Jeśli nie masz pewności, czego potrzebujesz, zmagasz się z trudną sytuacją
                      lub chcesz omówić otrzymaną diagnozę – oferujemy profesjonalne konsultacje 
                      online z psychologiem.
                      <br />
                      To bezpieczna przestrzeń do refleksji, uzyskania odpowiedzi i skierowania 
                      na właściwą ścieżkę.
                    </p>
                    <p>
                      Typowe sytuacje:
                    </p>
                    <ul>
                      <li>interpretacja wcześniejszej diagnozy</li>
                      <li>wstępna rozmowa przed podjęciem procesu</li>
                      <li>jednorazowe wsparcie w kryzysie</li>
                      <li>kontynuacja po zakończeniu diagnozy.</li>
                    </ul>

                    <p>
                      <strong>Czas trwania:</strong> 50-60 minut<br />
                      <strong>Cena:</strong> 200 zł za sesję 
                    </p>
                  </p>
                  <div className="text-end" style={{marginTop:'2rem'}}>
                    <Link to={`/umow-wizyte`} className="more-btn">
                      <BsFillArrowRightCircleFill /> Umów się na wizytę
                      <i className="bx bx-chevron-right"></i>
                    </Link>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default Offer;